/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Risk-Model-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 2019-06-28
 * Copyright All Rights Reserved
 */
// @flow
import * as React from 'react';
import { Col } from 'reactstrap';

type Props = {
  children: React.Node,
}
const SidebarComplement = ({ children }: Props) => (
  <Col
    md="9"
    className="px-4 ml-sm-auto"
    role="main"
  >
    {children}
  </Col>
);

export default SidebarComplement;



// WEBPACK FOOTER //
// ./js/components/support/layout/Sidebar/SidebarComplement.jsx